import TomSelect from "tom-select";

class selectTaxon extends HTMLElement {
  constructor() {
    super();
    this.$el = this.querySelector('select');
    this.$script = this.querySelector('script');
    this.initialValue = { species: null, taxon_id: null };
    this.taxa = [];
  }

  connectedCallback() {
    this.initTomSelect();
  }

  initTomSelect() {
    if (this.$script) {
      const data = JSON.parse(this.$script.textContent);
      this.initialValue = data.animal || { species: null, taxon_id: null };
      this.taxa = data.taxa || [];
    }

    let settings = {
      create: true,
      sortField: {
        field: "text",
        direction: "asc"
      },
      allowEmptyOption: true,
      placeholder: this.$el.getAttribute('placeholder') || 'Select an option...',
      onChange: this.onChange.bind(this),

      render: {
        option: this.renderOption.bind(this)
      }
    };

    const tomSelect = new TomSelect(this.$el, settings);

    // If a custom species value is the initialValue, add it to TomSelect and select it
    if (this.initialValue.species) {
      tomSelect.addOption({ value: this.initialValue.species, text: `${this.initialValue.species} (custom value)` }, true);
      tomSelect.addItem(this.initialValue.species);
      this.onChange(this.initialValue.species);
    }

    if (tomSelect.control_input) {
      tomSelect.control_input.setAttribute('tabindex', '0');
    }
  }

  onChange(value) {
    const match = this.taxa.find(taxon => taxon.id === parseInt(value));

    if (match === undefined) {
      this.$el.name = 'animal[species]';
    } else {
      this.$el.name = 'animal[taxon_id]';
    }
  }

  renderOption(item, escape) {
    const matchedItem = this.taxa.find(taxon => taxon.id === parseInt(item.value));

    if (matchedItem) {
      // For predefined taxa - show common name with scientific name below
      return '<div class="flex flex-col py-2">' +
        '<span class="font-medium">' + escape(matchedItem.common_name) + '</span>' +
        '<span class="text-sm text-gray-500 opacity-50 italic">' + escape(matchedItem.scientific_name) + '</span>' +
        '</div>';
    } else if (item.text === "Select a known species (optional)") {
      return '<div class="flex flex-col py-2">' +
        '<span class="font-medium">' + escape(item.text || item.value) + '</span>' +
        '</div>';
    } else {
      // For custom species - just show the value
      return '<div class="flex flex-col py-2">' +
        '<span class="font-medium">' + escape(item.text || item.value) + '</span>' +
        '<span class="text-sm text-gray-500 opacity-50 italic">Custom species</span>' +
        '</div>';
    }
  }

}

customElements.define("select-taxon", selectTaxon);

export default selectTaxon;

